var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rounded-full flex items-center justify-center text-center p-1.5 text-xs text-gray-900 border border-gray-400",style:({
    backgroundColor:
      _vm.userBackgroundColor === undefined ? '#4ECBC4' : _vm.userBackgroundColor,
    maxWidth: ((this.size) + "px"),
    maxHeight: ((this.size) + "px"),
  })},[_vm._v(" AÇ ")])}
var staticRenderFns = []

export { render, staticRenderFns }